import z from "zod";

export const guestSchema = z.object({
  fullName: z.string().min(1, "Full Name is required"),
  contractNumber: z.string().min(1, "Contract Number is required"),
});
